import script from "./PwaSignup.vue?vue&type=script&setup=true&lang=ts"
export * from "./PwaSignup.vue?vue&type=script&setup=true&lang=ts"

import "./PwaSignup.vue?vue&type=style&index=0&id=b897988e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b897988e"]])

export default __exports__